/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum QuantityUnitOfMeasure {
    Flat = 1,
    Miles = 2,
    Dollars = 3,
    Units = 4,
    Minutes = 6,
    Pounds = 9,
    Tons = 10,
    Hours = 15,
    Stops = 16,
}
